<template>
  <div class="fruit_con">
    <canvas id="fruitCanvas" :height="fruitHeight" :width="fruitWidth"
      >抱歉，您的浏览器不支持canvas元素</canvas
    >
  </div>
</template>

<script>
import FruitBG from "../assets/images/fruit_bg.webp";
export default {
  name: "FruitCanvas",
  props: {
    fruitHeight: {
      type: Number,
      default: 400,
    },
    fruitWidth: {
      type: Number,
      default: 800,
    },
  },
  mounted() {
    this.drawCanvas();
  },
  methods: {
    drawCanvas() {
      var canvas = document.getElementById("fruitCanvas");
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "green";
      ctx.fillRect(0, 0, this.fruitWidth, this.fruitHeight);
      var img = new Image();
      img.onload = function () {
        ctx.drawImage(img, 0, -150);
      };
      img.src = FruitBG;
    },
  },
};
</script>

<style lang="less" scoped>
.fruit_con {
  width: 100%;
  display: flex;
  // align-items: center;
  justify-content: center;
  #fruitCanvas {
  }
}
</style>
